<template>
    <div>
        <breadCrumb 
            :icon="'fa-calendar-alt'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_appointment`)"
            :subSubCategory="''">
        </breadCrumb>
      <div v-if="!addToggle" class="text-right mt-3 mr-5">
            <!-- <button v-b-toggle.addAppointmentModal class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t(`subMenu.my_salon_appointment`)">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`subMenu.my_salon_appointment`)}}</span>
            </button> -->
            <!-- <button v-b-toggle.addAppointmentWizard class="btn ml-1 buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t(`subMenu.my_salon_appointment`)">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`subMenu.my_salon_appointment`)}} Wizard(Dummy)</span>
            </button> -->
                        <button v-b-modal.addAppointmentModalX class="btn ml-1 buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t(`subMenu.my_salon_appointment`)">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`subMenu.my_salon_appointment`)}}</span>
            </button>
            <ul  class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
                <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.appointmentTabs" :key="t.id">
                    <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
                </li>
            </ul>
            <div class="px-1 px-sm-5 py-4">
                <div class="panel mb-0">
                    <div class="panel-hdr d-block pt-4 p-1">
                        <appointmentFilter ref="appointmentFilter" @selectedOutlet="selected" @skuList="skuTrigger" :tab="selectedTab"></appointmentFilter>
                    </div>
                    <div class="panel-container show">
                        <div class="panel-content">
                            <div class="tab-content mt-5">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <AddModal :sku="sku" /> -->
        <AddModalX :selected="selectedOutlet" @apptCreated="apptCreated" />
        <AddWizard :sku="sku" />
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import AppointmentFilter from './Appointment_Filter'
import AddModal from './Appointment_Add_Modal'
import AddModalX from './Appointment_Add_ModalX'
import AddWizard from './Appointment_Add_Wizard'
export default {
    name: 'MenuAppointment',
    components: {
        BreadCrumb, 
        AppointmentFilter,

        AddWizard,
        AddModalX
    },
    data(){
        return{
            addToggle: false,
            selectedTab: 'list',
            sku:[],
            selectedOutlet: {}
        }
    },
    methods:{
        skuTrigger(res){
            this.sku = res;
        },
        selected(sel){
            this.selectedOutlet = sel;
        },
        apptCreated(event){
            console.log(event)
            this.$refs.appointmentFilter.autoSetDate(event.arrivalDate)
        }
    }
}
</script>
